import React, { useState } from "react";
import { FiMaximize, FiCheck } from "react-icons/fi";

const ImageThumbnail = ({ image, isSelected, onClick, onOpenFullScreen }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      style={{
        position: "relative",
        border: isSelected ? "3px solid #4D7CFE" : "3px solid transparent",
        borderRadius: "6px",
        overflow: "hidden",
        transition: "all 0.2s ease",
        cursor: "pointer",
        transform: isHovered ? "translateY(-3px)" : "translateY(0)",
        width: "100%",
        height: "100%"
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClick}
    >
      <img
        src={image.url}
        alt={image.type === "original" ? "Original" : "Edited"}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          display: "block"
        }}
      />

      {/* Selected checkmark */}
      {isSelected && (
        <div 
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            backgroundColor: "#4D7CFE",
            color: "white",
            borderRadius: "50%",
            width: "24px",
            height: "24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 5,
            boxShadow: "0 2px 5px rgba(0,0,0,0.2)"
          }}
        >
          <FiCheck size={16} />
        </div>
      )}

      {/* Zoom button at top right */}
      {isHovered && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onOpenFullScreen();
          }}
          style={{
            position: "absolute",
            top: "10px",
            right: isSelected ? "44px" : "10px",
            backgroundColor: "rgba(255,255,255,0.9)",
            color: "#333",
            width: "28px",
            height: "28px",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "none",
            cursor: "pointer",
            boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
            zIndex: 5
          }}
          title="View full screen"
        >
          <FiMaximize size={16} />
        </button>
      )}

      {/* Hover overlay */}
      <div 
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0,0,0,0.2)",
          opacity: isHovered ? 1 : 0,
          transition: "opacity 0.2s ease"
        }}
      />

      <div style={{
        position: "absolute",
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        color: "white",
        fontSize: "0.75rem",
        padding: "0.25rem 0.75rem",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
      }}>
        {image.type === "original" ? "Original" : `${image.editType.charAt(0).toUpperCase() + image.editType.slice(1).replace(/([A-Z])/g, ' $1')}`}
      </div>
    </div>
  );
};

export default ImageThumbnail;
